import { isBrowserContext, isDevelopment } from "../util/ContextHelper";

/* eslint-disable no-console */

type ErrorInfo = Error | React.ErrorInfo;

enum LogLevel
{
    Fatal = "Fatal",
    Error = "Error",
    Warning = "Warning",
    Info = "Info",
    Debug = "Debug"
}

interface LogDataFormat
{
    level: LogLevel;
    message: string;
    error?: ErrorInfo;
}

export async function log(data: LogDataFormat): Promise<void>
{
    if (isBrowserContext() && !isDevelopment())
    {
        // Handle client-side logging
        // await fetch("/api/log", {
        //     method: "POST",
        //     headers: {
        //         "Content-Type": "application/json"
        //     },
        //     body: JSON.stringify(data)
        // });
    }
    else
    {
        // Handle server-side logging (prerendering)
        // Report back to the dotnet node services
        switch(data.level)
        {
            case LogLevel.Fatal:
            case LogLevel.Error:{
                console.error(data.message, data.error);
                break;
            }
            case LogLevel.Warning:{
                console.warn(data.message, data.error);
                break;
            }
            case LogLevel.Info:{
                console.info(data.message, data.error);
                break;
            }
            case LogLevel.Debug:{
                console.debug(data.message, data.error);
                break;
            }
        }
    }
    return Promise.resolve();
}

export function format(level: LogLevel, message: string, error?: ErrorInfo): LogDataFormat
{
    return { level: level, message: message, error: error };
}

export function logError(message: string, error: ErrorInfo)
{
    return log(format(LogLevel.Error, message, error));
}

export function logWarning(message: string, error?: ErrorInfo)
{
    return log(format(LogLevel.Warning, message, error));
}

export function logInfo(message: string)
{
    return log(format(LogLevel.Info, message));
}

export function logFatal(message: string, error: ErrorInfo)
{
    return log(format(LogLevel.Fatal, message, error));
}

export function logDebug(message: string)
{
    return log(format(LogLevel.Debug, message));
}

